<template>
	<div class="leftCon">
		<!-- 电梯统计 -->
		<div class="elvStatistic">
			<div class="subTitle">电梯统计</div>
			<!-- 总台数 -->
			<div class="totalNumCon">
				<img class="totalNumBG" :src="require('@/assets/totalNumBG.png')">
				<img class="elvImg" :src="require('@/assets/elv.png')">
				<div class="totalNum">
					<div class="numTitle">总台数</div>
					<div class="numFont num">{{elvTotalNum}}</div>
					<div><span class="line"></span></div>
				</div>
			</div>
			<!-- 比例图 -->
			<div class="allElvRatio">
				<div class="singleData" v-for="(item,index) in ratioData" :key="item.brandId">
					<div class="elvName">{{item.brandName}}</div>
					<div class="dataPlay">
						<div class="dataBGC" :style="{width:verticalNum*2+'px'}">
							<div :class="[index%2==0?'lightBlue':'lightYellow']"
								:style="{width:(item.rate*100).toFixed(1)+'%'}">
							</div>
							<div :class="[index%2==0?'grayBlue':'grayYellow']"
								:style="{width:((1-item.rate)*100).toFixed(1)+'%'}">
							</div>
						</div>
						<div class="verticalContainer">
							<div v-for="i in verticalNum" :key="i" class="verticalDiv"></div>
						</div>
					</div>
					<div class="dataNum">
						<span class="numFont numSet">{{item.nums}}</span>
						<span class="unit">台</span>
					</div>
					<div class="numFont ratio" :class="[index%2==0?'blueRatio':'yellowRatio']">
						{{(item.rate*100).toFixed(1)}}%
					</div>
				</div>
			</div>
		</div>
		<!-- 运行统计 -->
		<div class="runStatistics">
			<div class="subTitle">运行统计</div>
			<div class="statisticsData">
				<div class="runTimes">
					<div class="runTimesDes fontComStyle">运行总次数(次)</div>
					<div class="runTimesNum numFont numComStyle">{{runStatisticsData.totalrunTotalNumber ||0}}</div>
				</div>
				<div class="runDuration">
					<div class="runDurationDes fontComStyle">运行总时长(小时)</div>
					<div class="runDurationNum numFont numComStyle">{{toHour(runStatisticsData.totalrunTotalTime)}}
					</div>
				</div>
				<div class="openDoorTimes">
					<div class="openDoorTimesDes fontComStyle">开关门次数(次)</div>
					<div class="openDoorTimesNum numFont numComStyle">{{runStatisticsData.totalopenDoorTimes||0}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			verticalNum: 0,
			ratioData: [],
			elvTotalNum: 0,
			runStatisticsData: {},
			districtData: {}
		}
	},
	methods: {
		toHour(minutes) {
			return minutes ? (minutes / 60).toFixed(1) : 0
		},
		//电梯统计及各品牌数量，比例
		brandStatustic() {
			this.$api.brand(this.districtData).then(res => {
				if (res.errorCode == 0) {
					this.ratioData = res.data.list;
					this.elvTotalNum = res.data.total;
					this.$nextTick(() => {
						let ratioWidth = document.querySelector(".dataPlay");
						this.verticalNum = Math.floor(ratioWidth.offsetWidth / 2);
					})
				}
			})
		},
		//运行统计
		getRunStatisticsData() {
			this.$api.runStatistic(this.districtData).then(res => {
				if (res.errorCode == 0) {
					this.runStatisticsData = res.data
				}
			})
		}
	},
	created() {
		this.brandStatustic();
		this.getRunStatisticsData();
		window.addEventListener("setItem", () => {
			this.districtData = sessionStorage.getItem("district") ?
				JSON.parse(sessionStorage.getItem("district")) : {};
			this.brandStatustic();
			this.getRunStatisticsData();
		});
	},
}
</script>


<style lang="scss" scoped>
.leftCon {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	.subTitle {
		color: #fff;
		width: 100%;
		height: 50px;
		line-height: 50px;
		padding-left: 20px;
		background-image: url('../assets/subTitle.png');
		background-size: 100% 100%;
		letter-spacing: 6px;
		font-weight: 600;
		font-family: 'FZLTTHK--GBK1-0', 'FZLTTHK--GBK1';
	}
	.elvStatistic {
		flex: 3;
		.totalNumCon {
			margin-top: 20px;
			height: 130px;
			position: relative;
			.totalNumBG {
				width: 100%;
				height: 100%;
			}
			.elvImg {
				position: absolute;
				left: 50px;
				bottom: 0;
			}
			.totalNum {
				width: calc(100% - 170px);
				position: absolute;
				left: 170px;
				top: 50%;
				transform: translateY(-50%);
				& > div {
					width: 100%;
					text-align: center;
				}
				.numTitle {
					font-size: 14px;
				}
				.num {
					color: #00bcff;
					font-size: 40px;
					letter-spacing: 2px;
				}
				.line {
					display: inline-block;
					width: 20px;
					height: 3px;
					border-radius: 8px;
					background-color: #00bcff;
				}
			}
		}
		.allElvRatio {
			margin-top: 20px;
			height: calc(100% - 220px);
			display: flex;
			flex-direction: column;
			.singleData {
				height: 16.6%;
				display: flex;
				font-size: 14px;
				align-items: center;
				& > div {
					margin-left: 10px;
					&:nth-child(1) {
						margin-left: 0;
					}
				}
				.elvName {
					flex: 0 0 120px;
					text-align: right;
				}
				.dataPlay {
					flex: 1;
					position: relative;
					height: 20px;
					.dataBGC {
						display: flex;
						position: absolute;
						left: 0;
						top: 0;
						z-index: 1;
						height: 100%;
						.lightYellow {
							background-color: #ff6b00;
						}
						.grayYellow {
							background-color: #ff6b00;
							opacity: 0.3;
						}
						.lightBlue {
							background-color: #70b4e1;
						}
						.grayBlue {
							background-color: #70b4e1;
							opacity: 0.3;
						}
					}
					.verticalContainer {
						position: absolute;
						left: 0;
						top: 0;
						display: flex;
						z-index: 10;
						.verticalDiv {
							width: 2px;
							height: 20px;
							background-color: transparent;
							border-right: 1px solid #040911;
						}
					}
				}
				.dataNum {
					flex: 0 0 70px;
					.numSet {
						display: inline-block;
						width: 50px;
						text-align: center;
					}
					.unit {
						color: #92a7b1;
					}
				}
				.ratio {
					flex: 0 0 60px;
					font-size: 12px;
					text-align: center;
					font-weight: normal;
				}
				.yellowRatio {
					border: 1px solid #ff6b00;
					box-shadow: inset 0px 0px 8px 0px #ff6b00;
				}
				.blueRatio {
					border: 1px solid #70b4e1;
					box-shadow: inset 0px 0px 8px 0px #70b4e1;
				}
			}
		}
	}

	.runStatistics {
		flex: 2;
		margin-top: 40px;
		.statisticsData {
			height: calc(100% - 50px);
			display: flex;
			flex-direction: column;
			justify-content: space-around;
			align-content: space-around;
			.runComstyle {
				padding-left: 70px;
				display: flex;
				align-items: center;
				height: 60px;
				background-size: 100% 100%;
			}
			.fontComStyle {
				font-size: 12px;
				width: 100px;
			}
			.numComStyle {
				font-size: 30px;
				width: calc(100% - 100px);
			}
			.runTimes {
				@extend .runComstyle;
				background-image: url('../assets/runTimes.png');
				.runTimesDes {
					color: #a6bfd2;
				}
				.runTimesNum {
					color: #00bcff;
				}
			}
			.runDuration {
				@extend .runComstyle;
				background-image: url('../assets/runDuration.png');
				.runDurationDes {
					color: #bb9793;
				}
				.runDurationNum {
					color: #ff6b00;
				}
			}
			.openDoorTimes {
				@extend .runComstyle;
				background-image: url('../assets/openDoorTimes.png');
				.openDoorTimesDes {
					color: #abc4d9;
				}
				.openDoorTimesNum {
					color: #2162b3;
				}
			}
		}
	}
}
</style>